class CustomNumberCtrl {
  [x: string]: any;

  static $inject = ['$location', '$stateParams'];

  constructor($location, $stateParams) {
    this.$location = $location;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.isNew = this.$stateParams.isNew;

    if (this.isNew) {
      this.$location.search('isNew', null);
    }
  }

}

export default {
  controller: CustomNumberCtrl,
  template: require('./custom.number.html'),
  bindings: {
    msisdn: '<',
    plan: '<'
  }
};
